import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    PropertyDefinition, PropertyMappingType,
} from "app/library/layout-builder";
import { AccountSidebarProps } from "./types";
import { getMenuDefinitions } from 'components/cms/definitions';

export class AccountSidebarDefinitions extends CmsReactComponent<AccountSidebarProps> {
    static defaultProps = {};

    static schemaName = "account-sidebar";
    static schemaType = "navigation-component";

    static propertyDefinitions: PropertyDefinition[] = [{
        name: "title",
        mapping: {
            type: PropertyMappingType.String,
        },
        text: "Başlık",
    },
    ...getMenuDefinitions("menu", "Menü"),
    ];
}
